export default "__VITE_ASSET__BvncQTfr__"